module.exports = __webpack_public_path__ + "img/8ff28c1.png";